export function addEvent (obj, type, fn) {
  if (obj.attachEvent) { // ie
    obj.attachEvent('on' + type, function () {
      fn.call(obj)
    })
  } else {
    obj.addEventListener(type, fn, false)
  }
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
